export function flattenObject(input: any, prefix = ""): Record<string, any> {
	if (typeof input !== "object" || input === null) {
		return { [prefix]: input };
	}

	if (Array.isArray(input)) {
		if (input.some((item) => typeof item === "object" && item !== null)) {
			const flatArray: Record<string, any> = {};
			input.forEach((item, index) => {
				const key = `${prefix}.${index}`;
				const flatItem = flattenObject(item, key);
				Object.assign(flatArray, flatItem);
			});

			return flatArray;
		}

		return { [prefix]: input };
	}

	const flatObject: Record<string, any> = {};
	Object.keys(input).forEach((key) => {
		const value = input[key];
		const newKey = prefix + (prefix === "" ? "" : ".") + key;
		const flatValue = flattenObject(value, newKey);
		Object.assign(flatObject, flatValue);
	});

	return flatObject;
}
